// components
import Label from './label'

// types
import { BaseFieldProps } from '../field'

export type TextProps = {
	readonly type:
		| 'color'
		| 'date'
		| 'datetime-local'
		| 'email'
		| 'hidden'
		| 'month'
		| 'number'
		| 'password'
		| 'tel'
		| 'text'
		| 'time'
		| 'url'
		| 'week'
} & BaseFieldProps &
	React.InputHTMLAttributes<HTMLInputElement>

const Text = (props: TextProps): JSX.Element => {
	const { label, ...attr } = props
	return (
		<label>
			<Label label={label} required={attr.required} />
			<input {...attr} />
		</label>
	)
}

export default Text
